import React, { FC } from "react";
import { Stack, Zoom, Box, Chip } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { alpha } from "@mui/material/styles";

import { AccessibleBoard } from "../../features/player/playerSlice";

import { RegisterSelectBoard } from "./RegisterSelectBoard";

interface RegisterListBoardsDateProps {
  /** Clé jour civil `YYYY-MM-DD` ou date parsable. */
  date: string;
  accessibleBoards: AccessibleBoard[];
}

function formatBoardDayLabel(dateKey: string, boards: AccessibleBoard[]): string {
  const fromBoard = boards[0]?.date;
  if (fromBoard instanceof Date && !Number.isNaN(fromBoard.getTime())) {
    return fromBoard.toLocaleDateString("fr-FR", { dateStyle: "full" });
  }
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey);
  if (m) {
    const local = new Date(
      Number(m[1]),
      Number(m[2]) - 1,
      Number(m[3])
    );
    return local.toLocaleDateString("fr-FR", { dateStyle: "full" });
  }
  return new Date(dateKey).toLocaleDateString("fr-FR", { dateStyle: "full" });
}

export const RegisterListBoardsDate: FC<RegisterListBoardsDateProps> = (
  props: RegisterListBoardsDateProps
) => (
  <Zoom in>
    <Stack spacing={2.5} width="100%" alignItems="center">
      <Chip
        icon={<CalendarMonthOutlinedIcon sx={{ "&&": { fontSize: 20 } }} />}
        label={formatBoardDayLabel(props.date, props.accessibleBoards)}
        sx={(theme) => {
          const accent =
            theme.palette.mode === "dark"
              ? theme.palette.secondary.main
              : theme.palette.primary.main;
          return {
            height: "auto",
            py: 1,
            px: 0.5,
            fontWeight: 600,
            fontSize: "0.95rem",
            letterSpacing: 0.02,
            borderRadius: 999,
            maxWidth: "100%",
            whiteSpace: "normal",
            textAlign: "center",
            border: `1px solid ${alpha(accent, 0.45)}`,
            bgcolor:
              theme.palette.mode === "dark"
                ? alpha(theme.palette.secondary.main, 0.12)
                : alpha(theme.palette.primary.main, 0.08),
            color: theme.palette.text.primary,
            "& .MuiChip-icon": { color: accent },
          };
        }}
      />
      <Box sx={{ maxWidth: 1200, width: "100%", margin: "0 auto" }}>
        <Grid2
          container
          spacing={2}
          justifyContent="center"
          alignItems="stretch"
        >
          {props.accessibleBoards.map((b) => (
            <RegisterSelectBoard key={b.id} board={b} />
          ))}
        </Grid2>
      </Box>
    </Stack>
  </Zoom>
);
